<div class="login-details full-page-height">

    <div class="col-md-8 col-xs-12 login-card no-padding  ">
        <!-- <div class="col-md-6 hide-xs-sm no-padding img-section">
      <img class="img-responsive" src="assets/images/login.png">
    </div> -->
        <div class="col-md-12 no-padding center auth-form">
            <!-- <img class="header-logo" src="https://res.cloudinary.com/dzz4lppcu/image/upload/v1607238429/truventor/tru-logo.png"> -->
            <div class="custom-form">
                <h6>Log In To Your <span>Partner</span> Account</h6>
                <form [formGroup]="loginForm">
                    <label>Email</label>
                    <span class="form-error-text" *ngIf="loginForm.get('login').touched && loginForm.get('login').invalid">* Email is required</span>
                    <input type="email" name="login" formControlName="login">
                    <label>Password</label>
                    <span class="form-error-text" *ngIf="loginForm.get('password').touched && loginForm.get('password').invalid">* Password is required</span>
                    <input [type]=inputType type="password" name="password" formControlName="password" (keydown.space)="$event.preventDefault();" required>
                    <p class="field-icon pointer" *ngIf="inputType == 'Password'" (click)="toggleInputType(inputType)"><img src="assets/svg/eye-closed.svg"> </p>
                    <p class="field-icon pointer" *ngIf="inputType == 'text'" (click)="toggleInputType(inputType)"><img src="assets/svg/eye-open.svg"></p>
                    <div class="forgot">
                        <a class="link" routerLink="/forgot-password"> Forgot password ?</a>
                    </div>

                    <button (click)="onSubmit(loginForm)" [disabled]="!loginForm.valid">Login</button>
                    <div class="top-margin-sm register">
                        <p>Don't Have an account yet?&nbsp;<a class="link" routerLink="/signup">Register Here</a></p>
                    </div>
                </form>
            </div>
        </div>

    </div>